import { styled } from "styled-components";

export const ScreenCardWrapper = styled.div`
  width: 100%;
  min-height: 480px;
  background: #fff;
  border-radius: 20px;
  padding: 16px;
`;

export const ScreenCardHeader = styled.div<{ $eyesInnerColor?: string }>`
  display: flex;
  justify-content: center; //space-between;
  gap: 8px;
  margin-bottom: 16px;
  button {
    padding: 8px;
    border-radius: 50%;
    border: none;
    background: #f5f5f5;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;

    &[data-active="true"] {
      background: ${({ $eyesInnerColor }) => $eyesInnerColor || "#388D5D"};
    }
  }
  }
`;

export const ScreenCardContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #333;
`;
